// This *must* be kept in sync with Payout::CENTS_PER_CREDIT
export const CENTS_PER_CREDIT = 10

// This *must* be kept in sync with Payout::MINIMUM_REQUEST
export const MINIMUM_REQUEST = 100
